import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/shared/components/ui/Button';
import { ROUTES } from '@/routes/paths';

export function UnauthorizedPage() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-10 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-warning/10 text-warning">
        <ShieldAlert className="h-7 w-7" />
      </div>
      <div>
        <h1 className="text-display-sm font-semibold text-on-surface">Access restricted</h1>
        <p className="mt-1 text-body-md text-on-surface-variant">
          You don't have permission to view this page.
        </p>
      </div>
      <Link to={ROUTES.dashboard}>
        <Button variant="outline">Back to Dashboard</Button>
      </Link>
    </div>
  );
}
